<template>
    <div>
        <v-card class="soft-shadow pa-1 mb-4">
            <v-card-title class="strong-text--text">
                <v-icon color="strong-text" class="me-1">mdi-file-plus-outline</v-icon>
                <span>إضافة سؤال جديد</span>
            </v-card-title>
            <v-card-subtitle>إضافة سؤال جديد إلى بنك اﻷسئلة</v-card-subtitle>
            <v-card-text>
                <v-form ref="form" class="my-3" @submit="submit">
                    <v-select v-model="form.type" label="نوع السؤال *" outlined :items="[{text: 'اختيار من متعدد', value: 'choices'}, {text: 'صواب وخطأ', value: 'truefalse'}, {text: 'سؤال مقالي', value: 'essay'}]" :rules="[rules.global.required]" :disabled="loading"></v-select>
                    <v-textarea auto-grow rows="3" v-model="form.text" ref="textInput" autofocus label="نص السؤال *" outlined :rules="[rules.global.required]" :disabled="loading"></v-textarea>
                    <v-select v-model="form.difficulty_level" label="مستوى الصعوبة" outlined :items="[{text: 'عادي', value: 'normal'}, {text: 'سهل جداً', value: 'too_easy'}, {text: 'سهل', value: 'easy'}, {text: 'متوسط', value: 'medium'}, {text: 'صعب', value: 'difficult'}, {text: 'شديد الصعوبة', value: 'extreme'}]" :rules="[rules.global.required]" :disabled="loading"></v-select>
                    <v-file-input v-model="imageFile" ref="imageInput" accept="image/png, image/jpeg" outlined placeholder="اختر صورة" class="e-link" prepend-icon="" prepend-inner-icon="mdi-image" label="صورة السؤال" :disabled="loading"></v-file-input>
                    <v-autocomplete v-model="form.categories" chips label="التصنيفات *" multiple outlined :items="categoriesSelectItems" :menu-props="{ dense: true }" :rules="[rules.global.requiredArray]" :disabled="loading">
                        <template v-slot:selection="{ item }">
                            <v-chip color="primary" small label>
                                <span v-if="item.text.split('/').length > 1" style="opacity: 0.6">{{item.text.split('/')[0]}} / </span>
                                <span class="ms-1">{{item.text.split('/')[item.text.split('/').length-1]}}</span>
                            </v-chip>
                        </template>
                    </v-autocomplete>

                    <div v-if="form.type !== 'essay'">
                        <v-divider class="my-2"></v-divider>
                        <v-subheader class="text--text mb-2 px-0">اﻹجابات</v-subheader>
                        <v-row>
                            <template v-for="(answer, i) in answers">
                                <v-col cols="12" lg="6" :key="i" class="mb-4">
                                    <v-select v-if="form.type !== 'truefalse'" v-model="answers[i].type" hide-details outlined dense label="نوع اﻹجابة" :items="[{text: 'نص', value: 'text'}, {text: 'صورة', value: 'image'}]" class="mb-2" :disabled="loading"></v-select>
                                    <v-file-input v-if="answers[i].type === 'image'" v-model="answers[i].image" hide-details accept="image/png, image/jpeg" outlined placeholder="اختر صورة" prepend-icon="" prepend-inner-icon="mdi-image" label="صورة السؤال" class="e-link" :rules="[rules.global.required]" :disabled="loading"></v-file-input>
                                    <v-textarea v-else auto-grow hide-details rows="1" v-model="answers[i].text" :disabled="form.type === 'truefalse' || loading" label="نص اﻹجابة" outlined :rules="[rules.global.required]"></v-textarea>
                                    <div class="d-flex justify-space-between">
                                        <div>
                                            <v-checkbox v-model="answers[i].correct" label="إجابة صحيحة" color="green" hide-details class="mt-2"></v-checkbox>
                                        </div>

                                        <div>
                                            <v-btn v-if="form.type === 'choices' && answers.length > 2" text color="error" outlined small class="mt-2" @click="removeAnswer(i)" v-ripple="false">
                                                <v-icon left>mdi-delete</v-icon>
                                                <span>حذف</span>
                                            </v-btn>
                                        </div>
                                    </div>
                                </v-col>
                            </template>
                        </v-row>
                        <v-btn v-if="form.type === 'choices' && answers.length < 8" block text color="muted" outlined small class="mt-2" @click="addAnswer" v-ripple="false">
                            <v-icon left>mdi-plus-circle-outline</v-icon>
                            <span>إضافة إجابة أخرى</span>
                        </v-btn>
                    </div>

                    <v-divider class="my-6"></v-divider>

                    <div>

                        <v-checkbox v-model="addAnswerExplain" label="إضافة توضيح لإجابة السؤال الصحيحة" color="primary" hint="يظهر فقط أثناء تصفح الطالب لدرجاته وأخطائه بعد الامتحان" :persistent-hint="addAnswerExplain" class="mb-5 mt-0"></v-checkbox>
                        <div v-if="addAnswerExplain">
                            <v-textarea auto-grow rows="3" v-model="answerExplainText" ref="textInput" label="نص التوضيح" outlined :disabled="loading"></v-textarea>
                            <v-file-input v-model="answerExplainImageFile" ref="explainImageInput" accept="image/png, image/jpeg" outlined placeholder="اختر صورة" class="e-link" prepend-icon="" prepend-inner-icon="mdi-image" label="صورة التوضيح" :disabled="loading"></v-file-input>
                        </div>
                    </div>

                </v-form>
            </v-card-text>
        </v-card>
        <div class="d-flex py-4 mb-4">
            <v-spacer />
            <v-btn :disabled="loading" color="text" outlined large class="me-3" @click="resetForm">
                <v-icon left>mdi-reload</v-icon>
                إعادة الحقول
            </v-btn>
            <v-tooltip transition="fade-transition" bottom max-width="280" color="tooltip" :close-delay="300" open-on-focus>
                <template v-slot:activator="{on, attrs}">
                    <div v-on="on" v-bind="attrs">
                        <v-btn :disabled="loading" :loading="loading" color="primary" class="px-4" large @click="submit">
                            <v-icon size="20" class="me-1">mdi-file-plus</v-icon>
                            <span>إضافة إلى اﻷسئلة</span>
                        </v-btn>
                    </div>
                </template>
                <span>يمكنك الضغط على زر Enter</span>
            </v-tooltip>
        </div>


        <div class="actions">

            <!-- <action-dialog v-model="createDirectoryDialog" action="post" :url="`/exams/categories`" success-msg="تم إنشاء التصنيف" title="تصنيف جديد" button-text="إنشاء" :data="{name: newCategoryName, parent_category_id: currentDirectory ? currentDirectory.id : null}" @reset="newCategoryName = '';" @sync="addDirectory">
                <v-text-field v-model="newCategoryName" autofocus label="اسم التصنيف" placeholder="أدخل اسم التصنيف"></v-text-field>
            </action-dialog> -->
        </div>
    </div>
</template>

<script>

import GlobalComputed from '@/helpers/global-computed'
import GlobalMethods from '@/helpers/global-methods'

export default {
    components: {
        
    },
    props: {
        categories_select_items: {},
    },
    data() {
        return {
            page_url: '/exams/questions/create',
            loading: false,

            form: {
                text: '',
                difficulty_level: 'normal',
                type: 'choices',
                categories: [],
            },
            answers: [
                {type: 'text', text: '', image: null, correct: false,},
                {type: 'text', text: '', image: null, correct: false,},
                {type: 'text', text: '', image: null, correct: false,},
                {type: 'text', text: '', image: null, correct: false,},
            ],
            imageFile: null,

            addAnswerExplain: false,
            answerExplainImageFile: null,
            answerExplainText: '',

            rules: {
                global: {
                    required: value => !!value || 'لا يمكنك ترك الحقل فارغاً',
                    requiredArray: value => !!value.length || 'يجب تحديد اختيار واحد على اﻷقل',
                },
            }
        }
    },
    computed: {
        ...GlobalComputed,

        categoriesSelectItems(){
            if (this.categories_select_items){
                return this.categories_select_items.map(category=>{
                    const parent = category.parent_category_id ? this.categories_select_items.find(item=>item.id === category.parent_category_id) : null;
                    return {text: parent ? `${parent.name} / ${category.name}` : category.name, value: category.id};
                })
            }else{
                return [];
            }
        },
        queryCategory(){
            return this.$route.query.category ? parseInt(this.$route.query.category) : null;
        },
    },
    watch: {
        queryCategory(category){
            this.form.categories = [category];
        },
        form: {
            deep: true,
            handler(form){
                if (form.type === 'truefalse' && (this.answers.length !== 2 || this.answers[0].text !== 'صواب')){
                    this.answers = [
                        {type: 'text', text: 'صواب', image: null, correct: false,},
                        {type: 'text', text: 'خطأ', image: null, correct: false,},
                    ]
                }
            }
        }
    },
    methods: {
        ...GlobalMethods,
        resetForm(){
            this.form.text = '';
            this.imageFile = null;
            this.answerExplainImageFile = null;
            this.answerExplainText = '';

            if (this.form.type === 'choices'){
                this.answers = this.answers.map(()=>{
                    return {type: 'text', text: '', image: null, correct: false,};
                });
            }else{
                this.answers = this.answers.map(answer=>{
                    answer.correct = false;
                    return answer;
                })
            }
            this.$refs.form.resetValidation();
            this.$vuetify.goTo(0, {duration: 500});
            window.setTimeout(()=>{
                this.$refs.textInput.focus();
            }, 500)
        },
        addAnswer(){
            if (this.form.type === 'choices'){
                this.answers.push({type: 'text', text: '', image: null, correct: false,});
            }
        },
        removeAnswer(index){
            this.answers = this.answers.filter((answer, i)=>{
                return i !== index;
            })
        },
        mockData(){
            this.form.text = `لوريم إيبسوم طريقة لكتابة النصوص في النشر والتصميم الجرافيكي تستخدم بشكل شائع لتوضيح الشكل المرئي`;
            this.form.categories = [4,11];
            this.answers = [
                {type: 'text', text: 'اﻹجابة 1', image: null, correct: true,},
                {type: 'text', text: 'اﻹجابة 2', image: null, correct: false,},
                {type: 'text', text: 'اﻹجابة 3', image: null, correct: false,},
                {type: 'text', text: 'اﻹجابة 4', image: null, correct: false,},
            ]
        },
        setShortcutsListener(){
            window.addEventListener('keypress', e=>{
                // if key is "Enter"
                if (e.keyCode === 13 || e.which === 13){
                    if (!e.shiftKey && !e.ctrlKey && !e.altKey && e.target.tagName !== 'TEXTAREA'){
                        e.preventDefault();
                        this.submit();
                    }
                }
            })
        },
        submit(){
            if (this.validate()){
                if (!this.loading){
                    this.loading = true;
                    let data = new FormData();
                    data.append('text', this.form.text);
                    data.append('difficulty_level', this.form.difficulty_level);
                    data.append('type', this.form.type);
                    this.form.categories.forEach(category=>{
                        data.append('categories[]', category);
                    });
                    if (this.imageFile){
                        data.append('image', this.imageFile)
                    }

                    if (this.addAnswerExplain){
                        if (this.answerExplainText){
                            data.append('answer_explain_text', this.answerExplainText)
                        }
                        if (this.answerExplainImageFile){
                            data.append('answer_explain_image', this.answerExplainImageFile)
                        }
                    }
                    
                    this.answers.forEach((answer, i)=>{
                        Object.keys(answer).forEach(key=>{
                            if (answer[key] || answer[key] === false || answer[key] === 0){
                                data.append(`answers[${i}][${key}]`, answer[key]);
                            }
                        })
                    })

                    this.$store.dispatch('fastPostAction', {url: '/exams/questions', data}).then(response=>{
                        this.loading = false;
                        this.resetForm();
                        this.showMsg('تم إضافة السؤال بنجاح', 'success');

                    }).catch(e=>{
                        this.loading = false;
                        if (e.response && e.response.data && e.response.data.errors && Object.keys(e.response.data.errors).length){
                            const errors = e.response.data.errors;
                            let msg = errors[Object.keys(errors)[0]][0];
                            this.showMsg(msg, 'error');
                        }else{
                            const errorMsg = e && e.response.data ? e.response.data.message : null;
                            const msg = errorMsg || 'حدثت مشكلة أثناء تنفيذ طلبك';
                            this.showMsg(msg, 'error');
                        }
                    })
                }
            }
        },
        dataToFormData(data){
            let formData = new FormData();
            for (let property in data){
                if (Array.isArray && Array.isArray(data[property])){
                    data[property].forEach(el=>{
                        formData.append(property + '[]', el);
                    })
                }else{
                    formData.append(property, data[property]);
                }
            }
            return formData;
        },
        validate(){
            if (this.$refs.form.validate()){
                if (this.form.type === 'essay' || this.answers.some(answer=>answer.correct)){
                    return true;
                }else{
                    this.showMsg('يجب تحديد إجابة واحدة صحيحة على اﻷقل', 'warning');
                }
            }
            return false;
        }
    },
    created(){
        this.setShortcutsListener();
        if (this.queryCategory){
            this.form.categories = [this.queryCategory];
        }
    },
    mounted(){
        // this.mockData();
    }
}

</script>
